import { render, staticRenderFns } from "./FormulaMixDetail.vue?vue&type=template&id=04ac4016&scoped=true"
import script from "./FormulaMixDetail.vue?vue&type=script&lang=js"
export * from "./FormulaMixDetail.vue?vue&type=script&lang=js"
import style0 from "./FormulaMixDetail.vue?vue&type=style&index=0&id=04ac4016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ac4016",
  null
  
)

export default component.exports